// General UI icons
import SideListIcon from './side-list.svg';
import LockIcon from './lock.svg';
import QuestionIcon from './question.svg';
import LightIcon from './light.svg';
import ListIcon from './list.svg';
import LinkIcon from './link.svg';
import ClockIcon from './clock.svg';

export { SideListIcon, LockIcon, QuestionIcon, LightIcon, ListIcon, LinkIcon, ClockIcon };
